import { render, staticRenderFns } from "./outside-link.vue?vue&type=template&id=6b864482"
import script from "./outside-link.vue?vue&type=script&lang=js"
export * from "./outside-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b864482')) {
      api.createRecord('6b864482', component.options)
    } else {
      api.reload('6b864482', component.options)
    }
    module.hot.accept("./outside-link.vue?vue&type=template&id=6b864482", function () {
      api.rerender('6b864482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/outside-link.vue"
export default component.exports